// extracted by mini-css-extract-plugin
module.exports = {"default":"Avatar_default__1-kuE","loading":"Avatar_loading__25ydt"};